'use client'
import { useEffect } from 'react';
const pixelId = '1024405492468462'

const FBPixel = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('react-facebook-pixel').then((x) => x.default).then((ReactPixel) => {
        ReactPixel.init(pixelId);
        ReactPixel.pageView();
      });
    }
  }, []);

  return null;
};

export default FBPixel;